<template>
    <div>
        <div>
            <el-row :gutter="6" class="dy-wrp">
                <el-col :span="1">
                    <label>年份:</label>
                </el-col>
                <el-col :span="3">
                    <el-input v-model="year" type="text" placeholder="选择年,默认当前年"></el-input>
                </el-col>
                <el-col :span="1">
                    <label>月份:</label>
                </el-col>
                <el-col :span="3">
                    <el-input v-model="month" type="text" placeholder="选择月,默认当月"></el-input>
                </el-col>
                <!-- <el-col :span="3">
                    <el-input v-model="day" type="text" placeholder="选择日,默认当日"></el-input>
                </el-col> -->
                <el-col :span="3">
                    <el-button type="primary" @click="pullList">查询</el-button>
                </el-col>
            </el-row>
        </div>
        <h3>日统计 <span class="txt-tips">(仅供参考，数据有偏差)</span></h3>
        <el-table :data="everyStatis" stripe tooltip-effect="dark" fit>
            <el-table-column label="日期">
                <template slot-scope="scope">{{ scope.row.TravelStatis_Date }}</template>
            </el-table-column>
            <el-table-column label="增加人数">
                <template slot-scope="scope">{{ scope.row.TravelStatis_PersonAdd }}</template>
            </el-table-column>
            <el-table-column label="减少人数">
                <template slot-scope="scope">{{ scope.row.TravelStatis_PersonMinus }}</template>
            </el-table-column>
            <el-table-column label="人数合计">
                <template slot-scope="scope">{{ scope.row.TravelStatis_PersonTotal }}</template>
            </el-table-column>
            <el-table-column label="增加金额">
                <template slot-scope="scope">{{ scope.row.TravelStatis_MoneyAdd }}</template>
            </el-table-column>
            <el-table-column label="减少金额">
                <template slot-scope="scope">{{ scope.row.TravelStatis_MoneyMinus }}</template>
            </el-table-column>
            <el-table-column label="金额合计">
                <template slot-scope="scope">{{ scope.row.TravelStatis_MoneyTotal }}</template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: "",
            month: "",
            day: "",
            everyDayDrawer: false,
            orders: [],
            everyStatis: []
        };
    },
    mounted() {
        this.pullList();
        this.year = new Date().getFullYear()
        this.month = new Date().getMonth() + 1
        this.day = new Date().getDate()
    },
    methods: {
        pullList() {
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=statisday",
                {
                    year: this.year,
                    month: this.month,
                    // day:this.day
                },
                (res) => {
                    console.log("res:", res);
                    this.everyStatis = res.list;
                }
            );
        },
    },
};
</script>

<style scoped>
.dy-wrp label {
    margin: 10px 0;
    line-height: 40px;
}

.txt-tips {
    font-weight: normal;
    font-size: 13px;
    color: #666;
}

.el-collapse-item .el-row {
    padding: 6px 12px;
}

.search-wrp .el-input {
    width: 60%;
    margin-right: 10px;
}

.el-pagination {
    margin: 16px auto;
    text-align: center;
}
</style>